import { createClient } from '@supabase/supabase-js'
import { captureMessage } from './sentry'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://placeholder.supabase.co'
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'placeholder-key'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// BIG-74: capture edge-function failures from the client side. Catches
// the BIG-98-class "function returned 500" errors with the user's
// trigger context attached — no need to wait for a Supabase log dive.
// Webhook-triggered functions (Resend inbound, Stripe webhook) still
// need server-side reporting via _shared/sentry.ts; this only catches
// what the user actually invokes.
const _origInvoke = supabase.functions.invoke.bind(supabase.functions)
supabase.functions.invoke = async (name, options) => {
  const result = await _origInvoke(name, options)
  if (result?.error) {
    captureMessage(`Edge function failed: ${name}`, {
      level: 'error',
      tags: { function: name, surface: 'edge_function_invoke' },
      extra: {
        message: result.error?.message,
        status: result.error?.context?.response?.status,
      },
    })
  }
  return result
}
